module.exports = __webpack_public_path__ + "img/icon-blocked.4800da4f.svg";